<template>
  <div class="cargolist">
    <m-title :titlelist="listitem"></m-title>
    <div class="southcargonn">
      <div class="bigbox">
        <div class="southcargo_top">
          <!-- <columnper :itemper="jihua" :amount="alldun"></columnper> -->
          <div class="steer"><span style="font-weight: bold;">充电桩编号：</span>{{ session.name }}</div>
          <div class="southcargo_top_content" style="padding: 0 20px;">
            <ul>
              <li>充电桩状态：{{ datamsg.status }}</li>
              <li>充电次数：{{ datamsg.chargeCount }}</li>
            </ul>
            <ul>
              <li>充电时长：{{ datamsg.chargeTime }}分钟</li>
              <li>充电电量：{{ datamsg.chargeEnergy }}度</li>
            </ul>
            <ul>
              <li>充电金额：{{ datamsg.chargeElecMoney }}元</li>
              <li>充电服务费：{{ datamsg.chargeServiceMoney }}元</li>
            </ul>
            <ul>
              
              <li>充电总金额：{{ datamsg.chargeMoney }}元</li>
              <li>所属充电站：{{ datamsg.locationName }}</li>
            </ul>
          </div>
        </div>
        <div class="southcargo_bot">
          <div class="list_title">
            <div class="title-left">
              <span class="name">车牌号</span>
              <input type="text" placeholder="请输入" class="inp" style="width: 130px; height: 30px;" v-model="selectitem.plate" />
              <!-- <span class="name">充电桩状态</span>
              <div class="select_box1">
                <m-select :list="selectastrict" :value="astrictval" @input="chanval" style="height: 30px;"></m-select>
              </div> -->
              <span class="name">充电开始时间</span>
              <div class="select_box">
                <el-date-picker v-model="selectitem.starttime" type="datetime" placeholder="充电开始时间"
                  format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss " class="date">
                </el-date-picker>
                <span class="name">至</span>
                <el-date-picker v-model="selectitem.endtime" type="datetime" placeholder="充电结束时间" format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss" class="date">
                </el-date-picker>
              </div>
            </div>
            <div class="title-right">
              <button class="button2" @click="goback">返回</button>
              <button @click="searchdetail">查询</button>
              <button class="button1" @click="printList">导出</button>
            </div>
          </div>
          <div class="tablebox">
            <el-table height="90%" :data="tablelist.list" style="width: 100%; " border>
              <el-table-column label="序号" type="index" width="50px"></el-table-column>
              <el-table-column prop="chargingPileId" label="充电口编号" show-overflow-tooltip :render-header="renderHeader">
              </el-table-column>
              <el-table-column prop="chargingPileName" label="充电口名称" show-overflow-tooltip :render-header="renderHeader">
              </el-table-column>
              <el-table-column prop="deviceNo" label="车牌号" show-overflow-tooltip :render-header="renderHeader">
              </el-table-column>
              <el-table-column prop="status" label="司机" show-overflow-tooltip :render-header="renderHeader">
              </el-table-column>
              <el-table-column prop="chargeCount" label="联系方式" show-overflow-tooltip :render-header="renderHeader">
              </el-table-column>
              <el-table-column label="开始充电时间" width="180px" show-overflow-tooltip :render-header="renderHeader">
                <template v-slot="res">
                  <span>{{ mydateFormat(res.row.startTime, '时分秒') }}</span>
                </template>
              </el-table-column>
              <el-table-column label="充电结束时间" width="180px" show-overflow-tooltip :render-header="renderHeader">

                <template v-slot="res">
                  <span>{{ mydateFormat(res.row.endTime, '时分秒') }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="chargeTime" label="充电时长(分钟)" show-overflow-tooltip :render-header="renderHeader">
              </el-table-column>
              <el-table-column prop="chargePower" label="充电量(度)" show-overflow-tooltip :render-header="renderHeader">
              </el-table-column>
              <el-table-column prop="chargeElecMoney" label="充电金额（元）" show-overflow-tooltip
                :render-header="renderHeader">
              </el-table-column>
              <el-table-column prop="chargeServiceMoney" label="充电服务金额（元）" show-overflow-tooltip
                :render-header="renderHeader">
              </el-table-column>
              <el-table-column prop="chargeMoney" label="充电总金额（元）" show-overflow-tooltip :render-header="renderHeader">
              </el-table-column>
            </el-table>
            <div class="paging">
              <el-pagination :page-size="selectitem.limit" layout="total,prev, pager,next, jumper"
                :total="tablelist.totalCount" :current-page="tablelist.page" @current-change="handleCurrentChange">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mTitle from '@/components/mTitle';
import mChebox from '@/components/mChebox.vue';
// import columnper from '@/components/columnper';
import mSelect from '@/components/mSelect.vue';
import { printExcel } from '@/plugins/other.js';
export default {
  name: 'cargoinfo',
  data() {
    return {
      listitem: [{ name: "充电桩详情" }],
      datamsg: [],
      checked: 0,
      jihua: 0,
      alldun: 1,
      pno: '',
      name: '',
      page: '',
      limit: '',
      datevalue: '', //开始结束时间
      selectitem: {
        page: 1, //当前页码
        limit: 20, //每页显示条数
        params: null,
        piles: '',
        status: '',
        endtime: '',
        order: '',
        plate: '',
        sidx: '',
        starttime: '',
        station: '',
      },
      tablelist: {},
      tabledata: [],
      timeout: null,
      checked: false,
      astrictval: '全部',
      selectastrict: ['全部', '空闲中', '充电中'], //作业节点
      value1: '',
      session: {}
    };
  },
  components: {
    mTitle,
    // columnper,
    mChebox,
    mSelect,
  },
  created() {
    this.session = JSON.parse(sessionStorage.getItem('params')) || ""
    this.selectitem.station = this.$route.params.name || this.session.name
    this.getinfomsg();

  },

  methods: {
    //返回
    goback() {
      this.$router.go(-1)
    },
    //通过时间戳转换具体时间
    getSimpleDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      var minute = date.getMinutes();
      minute = minute < 10 ? '0' + minute : minute;
      var s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + s;
    },
    // 详情列表
    async getinfomsg() {
      const { data } = await this.$http(
        'api1',
        '/api/replenish/log/pileDatail',
        'get',
        {
          name: this.$route.params.name || this.session.name,
          page: this.$route.params.page || this.session.page,
          limit: this.$route.params.limit || this.session.limit,
        }
      );
      if (data.code != 0) return console.log('获取详情数据失败');
      this.datamsg = data.data.list[0];
      this.jihua = data.data.sumSullte || 0;
      this.alldun = data.data.plantons || 1;
      this.gettablelist();
    },
    //查询
    searchdetail() {
      this.gettablelist()
    },
    chanval(e) {
      this.astrictval = e;
      switch (e) {
        case '全部':
          this.$set(this.selectitem, 'status', null);
          break;
        case '空闲中':
          this.$set(this.selectitem, 'status', 1);
          break;
        case '充电中':
          this.$set(this.selectitem, 'status', 2);
          break;
      }
    },
    // 表格数据的获取
    async gettablelist(starttime = '', endtime = '') {
      this.selectitem.params = this.datamsg.params || null;
      this.selectitem.pno = this.datamsg.pno || null;
      const { data } = await this.$http(
        'api1',
        '/api/replenish/log/list',
        'get',
        this.selectitem,
        {
          starttime: starttime,
          endtime: endtime,
        }
      );
      if (data.code != 0) return console.log('获取表格数据失败');
      this.tablelist = data.data;
    },
    exportlist() {
      if (!this.datamsg.pno) return '';
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async (_) => {
        const { data } = await this.$http(
          'api1',
          '/driver/dispatchtruck/exportPlanDispatchTruckList',
          'get',
          { pno: this.datamsg.pno }
        );
        if (!data) return;
        this.tabledata = data.data;
        this.$nextTick((_) => {
          this.$print(this.$refs.tablelist);
        });
      }, 300);
    },
    // 分页
    handleCurrentChange(index) {
      if (this.tablelist.totalCount < this.selectitem.limit) return;
      this.selectitem.page = index;
      this.gettablelist();
    },
    //导出
    printList() {
      printExcel.call(
        this,
        '/api/replenish/log/exportEnergyLoglist',
        '充电记录列表',
        this.selectitem
      );
    },
    getsearch() {
      this.starttime = this.datevalue[0];
      this.endtime = this.datevalue[1];
      this.gettablelist(this.starttime, this.endtime);
    },

  },

};
</script>

<style lang="scss" scoped>

.cargolist {
  position: relative;
  height: 100%;

  .southcargonn {
    width: 100%;
    height: calc(100% - 50px);

    .bigbox {
      height: 100%;

      .southcargo_top {
        box-sizing: border-box;
        border-radius: 2px;
        background: #ffffff;
        padding: 10px;
        margin: 10px;
        border-radius: 20px;

        .steer {
          margin-left: 31px;
          margin-top: 5px;
        }

        .southcargo_top_content {
          font-size: 80%;
          display: flex;
          justify-content: space-between;

          ul {
            // display: flex;
            line-height: 45px;
          }

          li {
            padding: 0;
            margin: 0;
            list-style: none;
          }
        }
      }

      .southcargo_bot {
        box-sizing: border-box;
        margin: 10px;
        padding: 10px;
        border-radius: 20px;
        bottom: 0;
        overflow: auto;
        background: #ffffff;

        .list_title {
          position: relative;
          padding-left: 10px;
          padding-bottom: 10px;
          // height: 45px;
          // line-height: 55px;
          font-size: 80%;
          font-weight: bold;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .title-left {
            display: flex;
            justify-content: space-between;
            // align-items: center;

            .name {
              margin:0 10px;
              line-height: 30px;
            }
            .name:first-child{
              margin-left: 0;
            }
            .inp{
            
              padding-left: 10px;
              height: 30px;
              outline: none;
              border: none;
              background: #f3f4f5;
              border-radius: 2px;
            
            }
            .select_box1 {
              display: inline-block;

              font-weight: 400;
              height: 30px;
              line-height: 30px;
              background-color: #f3f4f5;
              width: 130px;
              
            }

            .select_box {
              display: inline-block;
              font-size: 80%;
              font-weight: 400;;

              .date {
                width: 200px;
              }
            }

            
          }

          .title-right {
            display: flex;
            justify-content: flex-end;
            align-items: center;

            button {
              width: 80px;
              height: 30px;
              background: #17b6a1;
              border-radius: 8px;
              border: none;
              color: #fff;
            }

            .button1 {
              width: 80px;
              height: 30px;
              background: #f5f6fa;
              border-radius: 8px;
              border: none;
              color: #17b6a1;
              margin-left: 20px;
            }

            .button2 {
              width: 80px;
              height: 30px;
              background: #f5f6fa;
              border-radius: 8px;
              border: none;
              color: #17b6a1;
              margin-right: 20px;
            }
          }


        }

        // .southcargo_bot_title {
        //   position: relative;
        //   box-sizing: border-box;
        //   height: 45px;
        //   font-size: 80%;
        // }
        .tablebox {
          // position: absolute;
          // top: 80px;
          // bottom: 0;
          width: 100%;
          overflow: hidden;
          height: 500px;

          .paging {
            // position: absolute;
            // width: 100%;
            // bottom: 0;
            height: 30px;
            text-align: center;
          }
        }
      }
    }
  }

  .tableprint {
    display: none;
  }
}
</style>
